import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from 'utils/translates';

import {
  dataRequest,
  selectRequestsStateById,
  selectItemById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

import MediumPreLoader from '../../../../../components/Common/PreLoaders/MediumPreLoader';

const eventsUserNoticesCollectionRN =
  'eventsModule.collections.eventsUserNoticesCollection';

class NotificationView extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.props.dataRequest();
  }

  render() {
    if (this.props.requestState.requestInProcess || !this.props.itemById) {
      return <MediumPreLoader />;
    }
    return (
      <React.Fragment>
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading">
            <div className="media full-width">
              <div className="media-left media-middle p-r-5">
                <span className="panel-title">
                  <a
                    href=""
                    onClick={e => {
                      e.preventDefault();
                      this.context.router.history.goBack();
                    }}
                  >
                    <i className="fa fa-angle-left fa-2x" />
                  </a>
                </span>
              </div>
              <div className="media-body media-middle full-width">
                <span className="panel-title">
                  <a
                    href=""
                    onClick={e => {
                      e.preventDefault();
                      this.context.router.history.goBack();
                    }}
                  >
                    {t('Назад')}
                  </a>
                </span>
              </div>
              <div className="media-right media-middle text-overflow">
                <Link to={'/main/customize-notifications'}>
                  {t('Настройки')}
                </Link>
              </div>
            </div>
          </div>
          <div className="panel-notify panel-notify-alone">
            <div className="media">
              <div className="media-left media-middle">
                <div className="avatar avatar-icon avatar-icon-sm avatar-icon-primary">
                  <i className="fa fa-star fa-lg" />
                </div>
              </div>
              <div className="media-body media-middle">
                <div className="media-info">
                  <span className="media-info-name">
                    {this.props.itemById.typeTitle}
                  </span>{' '}
                  <span className="media-info-desc">
                    {this.props.itemById.createdAtFormatted}
                  </span>
                </div>
                <div>{this.props.itemById.message}</div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

NotificationView.contextTypes = {
  router: PropTypes.shape()
};

NotificationView.defaultProps = {
  itemById: null,
  match: {
    params: { categoryId: '' }
  }
};

NotificationView.propTypes = {
  itemById: PropTypes.shape({
    typeTitle: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    createdAtFormatted: PropTypes.string.isRequired
  }),
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  dataRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  itemById: selectItemById(
    state,
    eventsUserNoticesCollectionRN,
    props.match.params.noticeId
  ),
  requestState: selectRequestsStateById(
    state,
    eventsUserNoticesCollectionRN,
    props.match.params.noticeId
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequest: () =>
    dispatch(
      dataRequest(eventsUserNoticesCollectionRN, props.match.params.noticeId)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationView);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationView/NotificationView.js